<div class="page-container" nz-row>
  <div class="accountProfile">

    @if(screenWidth > 992) {
      <nz-card class="ant-card-body-main" [nzBordered]="false">
        <h3 class="waec-card-header-text">{{'PROFILE.HEADER' | translate}}</h3>
        <p class="sub-header-text">{{'PROFILE.SUBHEADER' | translate}}</p>
  
  
        <div class="container_form">
          <div nz-row [nzGutter]="48">
            <div nz-col nzXs="24" nzSm="24" nzMd="24" nzLg="24" nzXl="16">
              <ul nz-menu [nzMode]="directions.HORIZONTAL" class="profile-tab">
                <li #rla="routerLinkActive" nz-menu-item *ngFor="let item of menuOption" [routerLinkActive]="'active-tab'"
                  class="item" [ngClass]="{
                    menu_display:
                      item.page.toLowerCase() === profilePages.IDENTIFICATION &&
                      disableIdentification === true
                  }" (mouseenter)="hoveredItem = item?.id" (mouseleave)="hoveredItem = null">
                  <img class="icon"
                    [src]="(rla.isActive || hoveredItem == item?.id) ? item?.activeIcon : item?.inactiveIcon" alt="">
                  <a class="profile-tab-text text-capitalize" [routerLink]="item.link">
                    {{ item.labelKey | translate}}
                  </a>
                </li>
              </ul>
  
              <div nz-row nzGutter="24">
                <nz-col [nzSm]="24" [nzXs]="24" [nzLg]="24">
                  <router-outlet></router-outlet>
                </nz-col>
  
  
              </div>
            </div>
  
            <nz-col nzXs="24" nzSm="24" nzMd="24" nzLg="24" nzXl="8">
              <app-stats></app-stats>
            </nz-col>
          </div>
  
  
        </div>
      </nz-card>
    } @else {

      <nz-card class="mobile-card mt-5">
        <nz-collapse [nzExpandIconPosition]="'end'">
          @for(panel of menuOption; track panel) {
            <nz-collapse-panel [nzHeader]="header" [nzShowArrow]="false" (click)="navigateToPanel(panel.link)" (nzActiveChange)="onPanelToggle($event, panel.link)" [nzActive]="activePanels.includes(panel.link)">
              <ng-template nz-collapse-panel-header #header>
                <div class="custom-header-content">
                  <div class="title">
                    <svg-icon [src]="router.url.includes(panel.link) ? panel?.activeIcon : panel?.inactiveIcon" alt=""></svg-icon>
                    <span class="panel-page-text">{{panel?.labelKey | translate}}</span>
                  </div>
                  <img class="arrow-icon" [src]="isPanelActive(panel.link) ? urls.CHEVRON_DOWN : urls.CHEVRON_RIGHT" [alt]="alts.ARROW">
                </div>
              </ng-template>
  
            
              @if(router.url.includes(panel.link)) {
                @switch (panel.page) {
                  @case (profilePages.BIODATA) {
                    <app-bio-data></app-bio-data>
                  }
                  @case (profilePages.PASSWORD) {
                    <app-change-password></app-change-password>
                  }
                  @case (profilePages.DELETE_ACCOUNT) {
                    <app-delete-account></app-delete-account>
                  }
                  @case (profilePages.API_KEY) {
                    <app-secret-key-generator></app-secret-key-generator>
                  }
                  @case (profilePages.COUNTRY_SETUP) {
                    <app-country-setup></app-country-setup>
                  }
                  @default {
                    <app-bio-data></app-bio-data>
                  }
                }
              }
            </nz-collapse-panel>
            
          }
        </nz-collapse>
  
        <div class="mt-5">
          <app-stats></app-stats>
        </div>
      </nz-card>
    }

  </div>
</div>